<template>
	<div class="pb-10">
		<div>
			<div class="page-tabs mb-6">
				<ul class="container flex flex-nowrap overflow-x-auto gap-2">
					<li v-if="!isExportOnly(user)" class="flex-shrink-0">
						<router-link to="/productie/proforme/ro"
							class="inline-block px-3 py-4 whitespace-nowrap border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300"
							:class="{ active: currentRoute == 'ProformeProductieRo' }">Proforme Productie
							RO</router-link>
					</li>
					<li class="flex-shrink-0"
						v-if="['admin', 'superuser'].includes(user.rol) || user.email_user == 'razvan.covaci@i-struct.ro' || user.email_user == 'alexandru.pietrariu@cuprolli.ro' || user.email_user == 'patrick.erdei@i-struct.ro'">
						<router-link to="/productie/proforme/eu"
							class="inline-block px-3 py-4 whitespace-nowrap border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300"
							:class="{ active: currentRoute == 'ProformeProductieEu' }">Proforme Productie
							EU</router-link>
					</li>
				</ul>
			</div>
		</div>
		<router-view />
	</div>
</template>

<script>
import { isExportOnly } from "@/utils";

export default {
	name: "ProformeProductie",
	computed: {
		user() {
			return this.$store.getters.loggedUser;
		},
		currentRoute() {
			return this.$route.name
		}
	},
	methods: {
		isExportOnly,
	}

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-tabs {
	@apply bg-white uppercase text-center text-gray-500 border-b border-gray-200 rounded-lg
}

.page-tabs li>.active {
	@apply text-blue-500 border-blue-500
}
</style>